<!-- 
    步骤条
    jay 2020-01-02
 -->
<template>
  <div class="step-wrap">
    <div class="stepCon active">
      <p class="stepTxt">1.{{ $t("recharge.fillMobileNumberAmount") }}</p>
    </div>
    <div class="stepCon" :class="{ active: tabNum != 0 }">
      <div class="step active"></div>
      <p class="stepTxt">2.{{ $t("recharge.confirmPay") }}</p>
    </div>
    <div class="stepCon" :class="{ active: tabNum == 2 }">
      <div class="step" :class="{ active: tabNum != 0 }"></div>
      <p class="stepTxt">3.{{ $t("common.done") }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabNum: {
      type: Number,
      default: function() {
        return 0;
      }
    }
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped></style>
